module.exports = __webpack_public_path__ + "assets/icons/app-logo.5d51fe499f069b354c49b37d0afc8fa6.svg";